module.exports = __webpack_public_path__ + "static/media/48_B.df5f309b.png";